import type { PostHog } from 'posthog-js';
import { usePostHog } from 'posthog-js/react';

import { isAnalyticsEnabled } from '../analytics/env';

/**
 * Returns the live PostHog client when analytics is enabled and the client has
 * mounted; otherwise `null`. Callers should treat `null` as "no-op" and emit
 * nothing — do NOT add a parallel `isAnalyticsEnabled()` check, this hook is
 * the single source of truth.
 */
export const usePostHogAnalytics = (): PostHog | null => {
  const posthog = usePostHog();

  return isAnalyticsEnabled() && posthog ? posthog : null;
};
